import { t } from '@/lib/i18n';
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';
import React from 'react';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('[ErrorBoundary] Caught an error:', error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    override render() {
        if (this.state.hasError) {
            return (
                <Box p={8} textAlign="center">
                    <VStack gap={4}>
                        <Heading size="lg">{t('error.title')}</Heading>
                        <Text color="gray.500">
                            {this.state.error?.message ?? t('error.unknown')}
                        </Text>
                        <Button size="sm" onClick={this.handleReset}>
                            {t('action.retry')}
                        </Button>
                    </VStack>
                </Box>
            );
        }

        return this.props.children;
    }
}
